import React, { useState } from "react";
import { createPortal } from "react-dom";
import { useGoogleLogin, useGoogleOAuth } from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginWithGoogle } from "../../Redux/actions/authActions";
import { toast } from "react-toastify";
import { loadSessionEssentials } from "../../Redux/actions/commonActtion";
import { Scrollx_animate } from "../../assets/icons";
import "../Login/login.css";
import "./SignUpWithGoogle.css";

const SignUpWithGoogle = ({ label = "Continue with Google" }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { scriptLoadedSuccessfully } = useGoogleOAuth();
  const [signInLoading, setSignInLoading] = useState(false);

  const handleSuccess = async (tokenResponse) => {
    const googleAccessToken = tokenResponse?.access_token;
    if (!googleAccessToken) {
      toast.error("Google sign-in did not complete. Please try again.");
      return;
    }

    setSignInLoading(true);
    try {
      const res = await dispatch(loginWithGoogle({ googleAccessToken }));
      if (res?.success) {
        localStorage.setItem("signedInWithGoogle", "true");
        // Load what the dashboard gates on while this loader is still up.
        const filled = await dispatch(loadSessionEssentials());
        navigate(filled === true ? "/dashboard" : "/new_user_survey");
      } else {
        toast.error("Google sign-in failed. Please try again.");
      }
    } catch (_error) {
      toast.error("Google sign-in failed. Please try again.");
    } finally {
      setSignInLoading(false);
    }
  };

  const handleError = () => {
    setSignInLoading(false);
    toast.error("Google sign-in failed. Please try again.");
  };

  const startGoogleLogin = useGoogleLogin({
    flow: "implicit",
    scope: "openid profile email",
    overrideScope: true,
    onSuccess: handleSuccess,
    onError: handleError,
    onNonOAuthError: handleError,
  });

  return (
    <>
      {/* Portal to body: the button sits inside animated (transformed)
          containers, which would trap a position: fixed overlay over the form. */}
      {signInLoading && createPortal(
        <div className="modal-overlayLoaderGoogle">
          <img
            src={Scrollx_animate}
            className="absolute opacity-80"
            width="120px"
            height="120px"
            alt=""
          />
          <p className="mt-[8rem] text-[0.9rem] text-white">Sign in with Google...</p>
        </div>,
        document.body,
      )}

      <button
        type="button"
        className="scrollx-google-button"
        onClick={() => startGoogleLogin()}
        disabled={signInLoading || !scriptLoadedSuccessfully}
        data-testid="scrollx-google-button"
      >
        <span className="scrollx-google-icon" aria-hidden="true">
          G
        </span>
        <span>{label}</span>
      </button>
    </>
  );
};

export default SignUpWithGoogle;
